document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".signposts").forEach((section) => {
        const pausePlayButton = section.querySelector(".signpostsControl");
        const pausePlayText = section.querySelector(".signpostsControlText");
        const pausePlayIcon = section.querySelector(".signpostsControlIcon");
        const signpostVideos = section.querySelectorAll("video");
        let paused = false;

        if (!pausePlayButton || signpostVideos.length === 0) return;

        const updateButton = () => {
            pausePlayText.textContent = paused ? "Play" : "Pause";
            pausePlayIcon.textContent = paused ? "play_arrow" : "pause";
            pausePlayButton.setAttribute("aria-pressed", String(paused));
        };

        const setPausedState = (shouldPause) => {
            paused = shouldPause;
            updateButton();
            signpostVideos.forEach((video) => {
                if (paused) {
                    video.pause();
                } else {
                    const playPromise = video.play();
                    if (playPromise !== undefined) {
                        playPromise.catch(() => {});
                    }
                }
            });
        };

        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            setPausedState(true); 
        } else {
            updateButton();
        }

        pausePlayButton.addEventListener("click", () => {
            setPausedState(!paused);
        });
    });
});
